import * as React from "react";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { PensionPathwayInvestmentOption } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/PensionPathwayInvestmentOption";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Documents } from "./Documents";
import { DocumentsAndDeclarationContent as Content } from "../../Resource/Contents";

interface IDeclarationsProps extends IProcessComponentProps {
    data: PensionContributionModel;
}

interface IDeclarationsState {
    checkedDeclarations: number[];
}

export class Declarations extends ProcessComponent<IDeclarationsProps, IDeclarationsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            checkedDeclarations: [],
        };
    }

    isValid() {
        const showInvestmentPathwayDeclaration = this.props.data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers?.InvestmentOption == PensionPathwayInvestmentOption.InvestmentPathway;
        const declarationsCount: number = showInvestmentPathwayDeclaration ? 3 : 2;
        if (this.state.checkedDeclarations.length < declarationsCount) {
            this.props.showErrorMsgPopUp(["Please accept the declaration to continue."], true);
        }

        return super.isValid() && this.state.checkedDeclarations.length == declarationsCount;
    }

    private getProps = () => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: data,
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data),
        };
    };

    private getComponentProps = (data: PensionContributionModel) => {
        return {
            data: data?.Contribution?.DrawdownModel,
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const showInvestmentPathwayDeclaration = data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers?.InvestmentOption == PensionPathwayInvestmentOption.InvestmentPathway;

        return (
            <>
                <h2>Documents available</h2>
                { <Documents {...this.getProps()}></Documents> }
                <h2>Declarations 1</h2>
            
                <h4>Lifetime allowance</h4>
                <p>
                    The information supplied by me as part of this instruction is true and complete to the best of my client's knowledge as at the date of this declaration. 
                    I understand that any false statement may result in HM Revenue & Custom imposing tax or other charges on my client.
                </p>

               <p>
               I confirm that I have explained to my client
               </p>
                    <ul>
                        <li className="mb-15">
                            that my client has to indemnify Aberdeen Platform Limited for any tax or other charges which occur due to the provision of false or misleading information by my client.
                            that the payment by Aberdeen Platform Limited as instructed by me discharges Aberdeen Platform Limited from all liabilities and claims in respect of benefits represented by such payment.
                            the tax-free cash recycling rules and that contributions to any registered pensions scheme as a result of tax-free cash received may attract an unauthorised payment tax charge.
                        </li>
                        <li className="mb-15">
                            the cancellation rights (if any) that apply to this pension benefit payment.
                        </li>
                        <li className="mb-15">
                            that if this payment is my client’s first benefit payment, their annual allowance will be reduced and the money purchase annual allowance will apply, and that my client can’t carry forward any unused annual allowance from previous tax years.
                        </li>
                        <li className="mb-15">
                            that my client needs to provide Aberdeen with any transitional tax free amount certificate and details of their lifetime allowance protection details if they wish them to be applied in respect of their benefit payment.
                            My client also authorises Aberdeen Platform Limited to check with HM Revenue & Customs any protection information supplied.
                        </li>
                    </ul>

                <p>
                    I confirm that I have provided my client with an illustration in relation to this benefit payment, in line with my regulatory responsibilities as financial adviser, as detailed in FCA Sourcebook COBS 14.
                </p>

                {showInvestmentPathwayDeclaration &&
                    <CheckboxGroup
                        type="block"
                        wrapCss="mb-0"
                        options={[
                            {
                                label: Content.declarations.investmentPathway,
                                value: this.state.checkedDeclarations.includes(3),
                                disabled: this.props.isReview,
                                onChange: (v) => {
                                    const checked = this.state.checkedDeclarations;
                                    if (v) {
                                        this.setState({ checkedDeclarations: checked.concat(3) });
                                    } else {
                                        this.setState({ checkedDeclarations: checked.filter((ele) => ele != 3) });
                                    }
                                },
                            },
                        ]}
                    />
                }

                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Confirm",
                            disabled: this.props.isReview,
                            value: this.state.checkedDeclarations.length == (showInvestmentPathwayDeclaration ? 3 : 2),
                            onChange: (v) => {
                                if (v) {
                                    this.setState({ checkedDeclarations: showInvestmentPathwayDeclaration ? [1, 2, 3] : [1, 2] });
                                } else {
                                    this.setState({ checkedDeclarations: [] });
                                }
                            },
                        },
                    ]}
                />
            </>
        );
    }
}
